<mat-form-field subscriptSizing="dynamic" class="w-full">
    @if (!!label || !!labelKey) {
        <mat-label>{{ label || (labelKey | transloco) }}</mat-label>
    }
    <input
        matInput
        type="text"
        mwlFlatpickr
        [formControl]="control | formControl"
        [convertModelValue]="true"
        [enableTime]="true"
        [locale]="locale()"
        [dateFormat]="dateFormat()"
        [altFormat]="dateFormat()"
        [time24hr]="true"
        [minDate]="min()" />
</mat-form-field>
